import React, { useEffect, useState } from "react"
import "./EditCourse.scss"
import CourseApi from "Api/CourseApi"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useLocation, useNavigate } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import programApi from "Api/programApi"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { toast, ToastContainer } from 'react-toastify'


const EditCourse = () => {
  document.title = "Edit Course"
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const location = useLocation()
  const course = location?.state
  const userData = JSON.parse(localStorage.getItem("userData"))

  const refinedProgramData = {
    ...course,
    modeOfStudy: {
      name:
        course?.modeOfStudy.charAt(0).toUpperCase() +
        course?.modeOfStudy?.slice(1),
      code:
        course?.modeOfStudy.charAt(0).toUpperCase() +
        course?.modeOfStudy?.slice(1),
    },
    verifiedStatus: {
      name:
        course?.verifiedStatus.charAt(0)?.toUpperCase() +
        course?.verifiedStatus?.slice(1),
      code:
        course?.verifiedStatus.charAt(0)?.toUpperCase() +
        course?.verifiedStatus?.slice(1),
    },
    verifiedReason: course?.verifiedReason ? course?.verifiedReason : "",
  }

  //   console.log(course)

  const [courseData, setCourseData] = useState(refinedProgramData)

  const [errors, setErrors] = useState({})

  const handleCourseDataChange = (name, value) => {
    setCourseData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors({ ...errors, [name]: "" })
  }
  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Course", link: "#" },
    { label: "Edit Course", link: "#" },
  ]
  const typeOptions = [
    { name: "underGraduate", code: "underGraduate" },
    { name: "postGraduate", code: "postGraduate" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    universityDropDown()
    fetchInstituteByUniId(courseData?.university?.universityCode)
  }, [accessToken])
  const [programMenu, setProgramMenu] = useState([])

  const getProgramMenuList = institutionCode => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    programApi
      .getProgramByInstitue(institutionCode, config)
      .then(res => {
        if (res.data.status) {
          setProgramMenu(res.data.program)
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    getProgramMenuList(courseData?.institution?.institutionCode)
  }, [instituteMenu])

  const ValidateCourse = Yup.object().shape({
    courseName: Yup.string().required(" Program name is required "),
    duration: Yup.string().required("Duration is required"),
    level: Yup.string().required("Level is required"),
    eligibilityCriteria: Yup.string().required(
      "Eligibility criteria is required",
    ),
    totalSeats: Yup.date()
      .typeError("Invalid Total Seats")
      .required("Total seats are required"),
    tuitionFee: Yup.date()
      .typeError("Invalid Tution Fee")
      .required("Tution fee is required"),
    admissionFee: Yup.string().required("Admission fee is required"),
    intakeYear: Yup.number()
      .typeError("Invalid Year")
      .min(1900, "Year cannot be less than 1900")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Intake Year fee is required"),
    modeOfStudy: Yup.string()
      .oneOf(["online", "offline", "hybrid"], "Invalid Mode of Study")
      .required("Mode of study  is required"),
    description: Yup.string().required("Description is required"),
    university: Yup.string().required("University is required"),
    institution: Yup.string().required("Institution is required"),
  })

  const updateCourse = () => {
    const payload = {
      ...courseData,
      university: courseData?.university?._id,
      institution: courseData?.institution?._id,
      Program: courseData?.Program?._id,
      modeOfStudy: courseData?.modeOfStudy?.name?.toLowerCase(),
      verifiedStatus: courseData?.verifiedStatus.name.toLowerCase(),
      courseId: courseData?._id,
    }

    setLoading(true)

    ValidateCourse.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        CourseApi.updateCourse(payload, config)
          .then(res => {
            if (res.data.status) {
              setLoading(false)
              setTimeout(() => {
                navigate("/courselist")
              }, 1000)  
              toast.success(res.data.message)

             
            }
          })
          .catch(error => {
            console.log(error)
            setLoading(false)
            toast.error(error.response.data.message)
          })
      })
      .catch(err => {
        setLoading(false)
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }

  return (
    <div className=" edit-course">
    <ToastContainer/>
      <Row>
        <Col xs="12">
          <div className="course-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Edit Course" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="course-edit-form ">
                <div className="course-edit-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.university}
                      onChange={e => {
                        handleCourseDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label
                    htmlFor="
                          Institution"
                  >
                    Institution
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.institution}
                      onChange={e => {
                        handleCourseDataChange("institution", e.value)
                        getProgramMenuList(e.value.institutionCode)
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                    />
                    {errors.Institution && (
                      <small className="error">{errors.Institution}</small>
                    )}
                  </div>
                </div>
                <div className="course-edit-inp">
                  <label htmlFor="CourseName">Program Name</label>

                  <div className="inp-err">
                    <Dropdown
                      id="courseName"
                      value={courseData.Program}
                      onChange={e => handleCourseDataChange("Program", e.value)}
                      options={programMenu}
                      optionLabel="programName"
                      placeholder="Choose Prorgam"
                      filter
                    />

                    {errors.Program && (
                      <small className="error">{errors.Program}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="courseName" className="label">
                    Course Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="courseName"
                      value={courseData.courseName}
                      onChange={e =>
                        handleCourseDataChange("courseName", e.target.value)
                      }
                      placeholder="Enter Course Name"
                      className="inp-field-box"
                    />
                    {errors.courseName && (
                      <small className="error">{errors.courseName}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={courseData.duration}
                      onChange={e =>
                        handleCourseDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                    {errors.duration && (
                      <small className="error">{errors.duration}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={courseData.level}
                      onChange={e =>
                        handleCourseDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                    {errors.level && (
                      <small className="error">{errors.level}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={courseData.eligibilityCriteria}
                      onChange={e =>
                        handleCourseDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                    {errors.eligibilityCriteria && (
                      <small className="error">
                        {errors.eligibilityCriteria}
                      </small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={courseData.totalSeats}
                      onChange={e =>
                        handleCourseDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                    {errors.totalSeats && (
                      <small className="error">{errors.totalSeats}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={courseData.tuitionFee}
                      onChange={e =>
                        handleCourseDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                    {errors.tuitionFee && (
                      <small className="error">{errors.tuitionFee}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={courseData.admissionFee}
                      onChange={e =>
                        handleCourseDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                    {errors.admissionFee && (
                      <small className="error">{errors.admissionFee}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="intakeYear" className="label">
                    IntakeYear
                  </label>
                  <div className="inp-err">
                    <Calendar
                      id="intakeYear"
                      value={
                        courseData.intakeYear
                          ? new Date(courseData.intakeYear, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleCourseDataChange("intakeYear", selectedYear)
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select Intake Year"
                    />
                    {errors.intakeYear && (
                      <small className="error">{errors.intakeYear}</small>
                    )}
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={courseData.modeOfStudy}
                      onChange={e =>
                        handleCourseDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                    {errors.modeOfStudy && (
                      <small className="error">{errors.modeOfStudy}</small>
                    )}
                  </div>
                </div>
                <div className="course-edit-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={courseData.description}
                      onChange={e =>
                        handleCourseDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>
                {userData.role === "manager" && (
                  <>
                    <div className="course-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={courseData.verifiedStatus}
                          onChange={e =>
                            handleCourseDataChange("verifiedStatus", e.value)
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="course-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={courseData.verifiedReason}
                          onChange={e =>
                            handleCourseDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    updateCourse()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditCourse
